let slideShowContainer = document.getElementById('slick-items-packLaboProduct');
let isSlider = false;
let productImgs;

function openSlideshow(e) {
    $('#rendersSlideshow--wrapper').addClass('active');
    productImgs = e.currentTarget.dataset.render.split('; ')
    productImgs.forEach((img, index) => {
        slideShowContainer.insertAdjacentHTML("beforeend", `
            <div class="w">
            <img src="${img}" alt="">
            </div>
        `)
        isSlider = true
    });
    if (isSlider) {
        $('#slick-items-packLaboProduct').slick({});
    }
}

function  closeSlideshow() {
    $('#rendersSlideshow--wrapper').removeClass('active');
    $('#slick-items-packLaboProduct').slick('unslick');
    slideShowContainer.innerHTML = '';
}

$('.packlaboSlideshow--button').click(openSlideshow)
$('.pfeil--close').click(closeSlideshow)

// $("body").on("click",".packlaboSlideshow--button", openSlideshow)
// $("body").on("click",".pfeil--close", closeSlideshow)